/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsUserAddOns
 */
export interface IdentityMelcoModelsUserAddOns {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    trial_days?: number;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    trial_start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    trial_end_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    activated_on?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    expiration_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserAddOns
     */
    cancelled_on?: Date | null;
}

export function IdentityMelcoModelsUserAddOnsFromJSON(json: any): IdentityMelcoModelsUserAddOns {
    return IdentityMelcoModelsUserAddOnsFromJSONTyped(json, false);
}

export function IdentityMelcoModelsUserAddOnsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsUserAddOns {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'trial_days': !exists(json, 'trial_days') ? undefined : json['trial_days'],
        'trial_start_date': !exists(json, 'trial_start_date') ? undefined : (json['trial_start_date'] === null ? null : new Date(json['trial_start_date'])),
        'trial_end_date': !exists(json, 'trial_end_date') ? undefined : (json['trial_end_date'] === null ? null : new Date(json['trial_end_date'])),
        'activated_on': !exists(json, 'activated_on') ? undefined : (json['activated_on'] === null ? null : new Date(json['activated_on'])),
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'start_date': !exists(json, 'start_date') ? undefined : (json['start_date'] === null ? null : new Date(json['start_date'])),
        'expiration_date': !exists(json, 'expiration_date') ? undefined : (json['expiration_date'] === null ? null : new Date(json['expiration_date'])),
        'cancelled_on': !exists(json, 'cancelled_on') ? undefined : (json['cancelled_on'] === null ? null : new Date(json['cancelled_on'])),
    };
}

export function IdentityMelcoModelsUserAddOnsToJSON(value?: IdentityMelcoModelsUserAddOns | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'type': value.type,
        'trial_days': value.trial_days,
        'trial_start_date': value.trial_start_date === undefined ? undefined : (value.trial_start_date === null ? null : value.trial_start_date.toISOString()),
        'trial_end_date': value.trial_end_date === undefined ? undefined : (value.trial_end_date === null ? null : value.trial_end_date.toISOString()),
        'activated_on': value.activated_on === undefined ? undefined : (value.activated_on === null ? null : value.activated_on.toISOString()),
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'start_date': value.start_date === undefined ? undefined : (value.start_date === null ? null : value.start_date.toISOString()),
        'expiration_date': value.expiration_date === undefined ? undefined : (value.expiration_date === null ? null : value.expiration_date.toISOString()),
        'cancelled_on': value.cancelled_on === undefined ? undefined : (value.cancelled_on === null ? null : value.cancelled_on.toISOString()),
    };
}


